// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"8bc6c977","252":"e994f1af"}[chunkId] + ".chunk.js";
};